import { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { UIContext } from '../../contexts/UIContext';

import { useGetVectorFocus } from '../../hooks/useVectorFocusService';

import VectorFocusService from '../../services/VectorFocusService';

import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import VectorFocus from '../../components/VectorFocus/VectorFocus';
import MapVisualizer from '../../components/MapVisualizer/MapVisualizer';
import ConfirmationDialogue from '../../components/ConfirmationDialogue/ConfirmationDialogue';
import WarningIcon from '@mui/icons-material/Warning';

import './VectorFocusDetails.scss';

function VectorFocusDetails() {
  const { authUser, isAuthorized } = useContext(AuthContext);
  const {showErrorMessage} = useContext(UIContext);

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [, vectorFocus] = useGetVectorFocus({
    id: location.state?.vectorFocusId || params?.id
  });
  const [showMap, setShowMap] = useState(false);
  const [showConfirmationDialogue, setShowConfirmationDialogue] = useState(false);
  const isOwnedByUser = authUser?.roles?.agent?.city?.id === vectorFocus?.city?.id;

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  function handleClickToggleMapVisibility() {
    setShowMap(!showMap);
  }

  function handleGoToVectorFocusUpdate() {
    navigate('/vector-focus-update', {
      state: {
        vectorFocusId: location.state?.vectorFocusId
      }
    });
  }

  async function handleClickDelete() {
    setShowConfirmationDialogue(true);
  }

  function handleCloseConfirmationDialogue(confirmed) {
    setShowConfirmationDialogue(false);
    if (!confirmed) return;
    deleteVectorFocus(vectorFocus?.id);
  }

  async function deleteVectorFocus(vectorFocusId) {
    const vectorFocusService = new VectorFocusService();
    const resUpdateFocus = await vectorFocusService.deleteVectorFocus({
      vectorFocusId: vectorFocusId
    });

    if (resUpdateFocus.status !== 1) {
      showErrorMessage({
        message: "Não foi possível deletar o foco"
      });
      return;
    }
    navigate(-1);
  }

  return (
    <div className="inner-page vector-focus-details-page">
      <Header
        showBackBtn
        hideBackBtnLabel
        pageTitle="Detalhes do Foco"
      />
      <div className="inner-page-content-container">
        <ConfirmationDialogue
          title="Deletar Foco"
          cancelLabel="Cancelar"
          confirmLabel="Confirmar"
          open={showConfirmationDialogue}
          onClose={handleCloseConfirmationDialogue}
        >
          <div className="delete-vector-focus-warning">
            <WarningIcon className="warning-icon"/>
            <p>Tem certeza que deseja deletar este foco? Esta ação não poderá ser desfeita.</p>
          </div>
        </ConfirmationDialogue>
        {!showMap ? (
          <VectorFocus
            vectorFocus={vectorFocus}
            isOwnedByUser={isOwnedByUser}
            handleGoToVectorFocusUpdate={handleGoToVectorFocusUpdate}
            handleClickDelete={handleClickDelete}
            handleClickShowOnMap={handleClickToggleMapVisibility} />
        ) : (
          <MapVisualizer
            className="vector-focus-map"
            vectorFocus={vectorFocus}
            handleClickHideMap={handleClickToggleMapVisibility}
          />
        )}
      </div>
      <BottomMenu />
    </div>
  );
}

export default VectorFocusDetails;
